import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Formik, Field } from 'formik';
import Button from '../utility/Button';
import CustomInput from '../utility/CustomInput';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { getAuthErr } from '../../js/utility';

import {
  doChangePassword,
  clearAuthError,
  doCheckCurrentUser,
} from '../../actions/auth';

import {
  SITE_TITLE,
} from '../../constants';

import { validateRequired, validatePassword, validateMatchPassword } from '../../js/validators';

class ChangePassword extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.clearAuthError();
    this.props.doCheckCurrentUser();
  }
    
  render() {
    const { authError,
      doChangePassword,
      passwordIsReset,
      loading,
      t,
    } = this.props;

    let message = t('form:passwordChangeSuccess');

    return (
      <>
        <Helmet>
          <title>{t('form:changePassword')} | { SITE_TITLE }</title>
        </Helmet>
        <div className="fe-auth-container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-5">
                <div className="fe-auth-content">
                  <h1 className="fe-auth-heading">{t('form:changePassword')}</h1>
                  { passwordIsReset ? <div className="fe-auth-text">{ message }</div> : null }
                  { !passwordIsReset ? 
                    <Formik
                      validateOnChange={true}
                      validateOnBlur={true}
                      initialValues={{ 
                        oldPassword: '',
                        newPassword: '',
                        retypeNewPassword: '',
                      }}
                      onSubmit={(values) => {
                        doChangePassword(
                          values.oldPassword,
                          values.newPassword,
                        );
                      }}
                    >
                      {({ values, handleSubmit }) => (
                        <form
                          noValidate
                          onSubmit={ handleSubmit }
                          className="fe-form"
                        >
                          <div className="fe-form-content">
                            <div className="fe-form-field full">
                              <label htmlFor="code">{t('form:currentPassword')}</label>
                              <Field
                                type="password"
                                name="oldPassword"
                                isPassword
                                component={CustomInput}
                                validate={validateRequired}
                              />
                            </div>
                            <div className="fe-form-field full">
                              <label htmlFor="password">{t('form:newPassword')}</label>
                              <Field
                                type="password"
                                name="newPassword"
                                isPassword
                                component={CustomInput}
                                validate={validatePassword}
                              />
                            </div>
                            <div className="fe-form-field full">
                              <label htmlFor="retypePassword">{t('form:confirmNewPassword')}</label>
                              <Field
                                type="password"
                                name="retypeNewPassword"
                                isPassword
                                component={CustomInput}
                                validate={(val) => validateMatchPassword(val, values.newPassword)}
                              />
                            </div>               
                            <Button
                              className="btn-auth"
                              type="submit"
                              disabled={loading}
                            >
                              { loading ? `${t('form:submitting')}...` : t('form:save') }
                            </Button>
                          </div>
                          <span className="fe-form-error">{ authError ? t(`error:${getAuthErr(authError.code)}`) : '' }</span>
                        </form>
                      )}
                    </Formik> : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

ChangePassword.propTypes = {
  authError: PropTypes.object,
  clearAuthError: PropTypes.func.isRequired,
  doCheckCurrentUser: PropTypes.func.isRequired,
  doChangePassword: PropTypes.func.isRequired,
  passwordIsReset: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};

const mapStateToProps = ({ authState }) => ({
  authError: authState.authError,
  loading: authState.loading,
  passwordIsReset: authState.passwordIsReset,
});

const mapDispatchToProps = {
  doChangePassword,
  clearAuthError,
  doCheckCurrentUser,
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(ChangePassword));